<template>
  <v-app-bar app flat absolute color="transparent">
    <div class="w-full">
      <div class="d-flex align-center mx-2">
        <v-app-bar-nav-icon v-if="app.config.sideBarShow" class="me-4" @click="$emit('appBarNavClick')"></v-app-bar-nav-icon>
        <app-logo v-else class="me-4"></app-logo>
      </div>
    </div>
  </v-app-bar>
</template>

<script setup>
import AppLogo from "./AppLogo.vue";
import { defineProps, defineEmits } from 'vue'
import { useAppStore } from "@/store/app";

const emits = defineEmits(['appBarNavClick'])
const app = useAppStore()
</script>